import React from "react";
import Calendar from "../Calendar/Calendar";
import { DateRangePickerProps, CalendarValue } from "../../../types";
import { parseYMD, formatYMD } from "../../../utils";
import calendarIcon from "../../../assets/icons/calendar.svg";
import "./DateRangePicker.css";

const DateRangePicker: React.FC<DateRangePickerProps> = ({
  startDate,
  endDate,
  onChange,
  isOpen = false,
  onToggle,
  label = "Date Range",
  className = "",
  style,
}) => {
  const handleCalendarChange = (val: CalendarValue) => {
    if (Array.isArray(val) && val[0] && val[1]) {
      onChange(formatYMD(val[0]), formatYMD(val[1]));
    }
  };

  return (
    <div className={`attendance-field date-picker-wrapper ${className}`} style={style}>
      {label && <label>{label}</label>}
      <div className="input-with-icon" onClick={onToggle}>
        <input
          type="text"
          readOnly
          value={`${startDate} → ${endDate}`}
          className="date-input"
        />
        <img src={calendarIcon} alt="Calendar" className="calendar-icon-img" />
      </div>
      {isOpen && (
        <div className="calendar-popover-dropdown">
          <Calendar
            value={[parseYMD(startDate), parseYMD(endDate)]}
            selectRange={true}
            onChange={handleCalendarChange}
          />
        </div>
      )}
    </div>
  );
};

export default DateRangePicker;
